// Handing a file made in the browser to the user as a download.

// `name` cut down to what any file system accepts, or `fallback` when nothing
// of it survives.
export const sanitizeFilename = (name, fallback = 'submission') =>
  (name || fallback).replace(/[^a-zA-Z0-9-_]+/g, '_').replace(/^_+|_+$/g, '') || fallback;

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
